import { Snapshot } from '@ember-data/store';
import type ModelRegistry from 'ember-data/types/registries/model';
import ApplicationAdapter, {
  type IAdapterOptions,
} from 'uplisting-frontend/adapters/application';

export default class AccountConfigurationAdapter extends ApplicationAdapter {
  urlForUpdateRecord<K extends keyof ModelRegistry>(
    id: string,
    modelName: K,
    snapshot: Snapshot<K>,
  ): string {
    const url = super.urlForUpdateRecord(id, modelName, snapshot);

    if (snapshot.adapterOptions) {
      const queryParams = this.formatQueryParams(
        snapshot.adapterOptions as IAdapterOptions,
      );

      return `${url}?${queryParams}`;
    }

    return url;
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'account-configuration': AccountConfigurationAdapter;
  }
}
